import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "16px",
    borderBottom: "none",
  },
  paper: {
    display: "flex",
    justifyContent: "space-between",
    background: "#F9FAFA",
    boxShadow: "none",
    padding: theme.spacing(3, 2),
    gap: 16,
    alignItems: "flex-end",
  },
  leftBox: {
    display: "flex",
    gap: 8,
  },
  rightBox: {
    display: "flex",
    gap: 8,
  },
  label: {
    color: "#5F6164",
    fontSize: 14,
    marginBottom: 4,
    textTransform: "capitalize",
  },
  statsSection: {
    display: "flex",
    gap: theme.spacing(2),
  },
  statsContainer: {
    flexGrow: 1,
    background: "#F9FAFA",
    padding: theme.spacing(2, 3),
    borderRadius: 8,
    marginBottom: theme.spacing(2),
  },
  statsTitle: {
    fontSize: 18,
    fontWeight: 500,
  },
  statsBox: {
    marginTop: 8,
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    justifyContent: "space-between",
  },
  contentBox: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 2),
    maxHeight: "calc(100vh - 210px)",
    overflow: "scroll",
  },
  tableContainer: {
    scrollbarWidth: "none",
    display: "inline-block",
    width: "auto",
    maxWidth: "none",
    position: "relative",
    boxShadow: "none",
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
    borderRight: `1px solid #BEBFC0`,
    maxHeight: "calc(100vh - 288px)",
  },
  tableContainer2: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    position: "relative",
    boxShadow: "none",
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    border: "none",
    maxHeight: "calc(100vh - 280px)",
    overflow: "auto",
  },
  tableCell: {
    position: "relative",
    borderBottom: "1px solid #BEBFC0",
    padding: "16px 0px",
    background: "#F9FAFA",
  },
  tableHeadCell: {
    borderBottom: "2px solid #BEBFC0",
    padding: "12px 0px",
    background: "#F9FAFA",
    top: 0,
    zIndex: 3,
    "&.MuiTableCell-stickyHeader": {
      background: "#F9FAFA",
    },
  },
  tableCellContent: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    paddingLeft: 14,
    paddingRight: 14,
  },
  vanNumberText: {
    whiteSpace: "pre",
    width: "max-content",
    lineHeight: 1.3,
  },
  cellInput: {
    width: "100%",
  },
  borderCellRightLight: {
    borderRight: "1px solid #E0E0E0",
  },
  fixedHeight: {
    height: 60,
  },
  tableCellOffboarded: {
    background: "#ffedec",
  },
  tableCellOffboardedInfo: {
    background: "#fff8e1ff",
  },
  valueHighlight: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: "0 5px",
    borderRadius: 4,
  },
  valueOk: {
    background: "#A8DABC",
  },
  valueBad: {
    background: "#F5AAAA",
  },
  dateCell: {
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  tableFooter: {
    borderTop: "1px solid #BEBFC0",
    width: "100%",
    height: 64,
    padding: theme.spacing(1, 0),
    position: "sticky",
    background: "#F9FAFA",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    bottom: 0,
  },
  settingsBtn: {
    borderColor: "#828487",
    padding: theme.spacing(0.9, 1),
    borderRadius: 5,
    "& .MuiButton-label": {
      display: "flex",
      gap: 8,
    },
    "& .MuiSvgIcon-root": {
      color: "#5F6164",
    },
  },
  activeRow: {
    background: "#0129FA1A",
  },
  gridBox: {},
  "@media (max-width: 1280px)": {
    statsSection: {
      flexDirection: "column",
    },
    paper: {
      flexDirection: "column",
    },
    leftBox: {
      alignSelf: "flex-start"
    }
  },
  "@media (max-width: 840px)": {
    contentBox: {
      margin: theme.spacing(0),
    },
    rightBox: {
      flexDirection: "column",
      alignItems: "flex-end",
    },
    leftBox: {
      width: "100%",
      alignSelf: "stretch",
    },
    gridBox: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gridColumnGap: 10,
      gridRowGap: 10,
      "& > *": {
        minWidth: 0,
        width: "100%",
      },
      "& .MuiInputBase-root": {
        width: "100%",
        minWidth: 0,
      },
    },
  }
}));
